  import { HttpErrorResponse } from "@angular/common/http";
  import { Component, Inject, OnInit } from "@angular/core";
  import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
  import { MatSnackBar } from "@angular/material/snack-bar";
  import { NgxSpinnerService } from "ngx-spinner";
  import { Deployment } from "src/app/core/models/deployment";
  import { DeploymentService } from "src/app/core/services/deployment.service";
  import { EnvironmentService } from "src/app/core/services/environment.service";
  import { NodeService } from "src/app/core/services/node.service";
  import { PeroformNodeAction } from "../../../../core/models/globals";

  @Component({
    selector: "app-nodeaction-confirm",
    templateUrl: "./nodeaction-confirm.component.html",
    styleUrls: ["./nodeaction-confirm.component.scss"],
  })
  export class NodeactionConfirmComponent implements OnInit {
    actionName: string = this.data.actionName;
    actionValue: string = this.data.actionVal;
    message: string = this.data.message;
    showWarning: boolean = this.data.showWarning;
    useVncFile: boolean = false;
    openConsoleAction: boolean = false;
    noteMessage: string =
      "Note : To open console you need to have virt-viewer installed.";
    //HardCode as of now to skip the action for the cloud deployment.
    skipCloudDeployment: boolean = true;
    constructor(
      public dialog: MatDialogRef<NodeactionConfirmComponent>,
      @Inject(MAT_DIALOG_DATA)
      public data: {
        node: string;
        nodeType: string;
        deployment: string;
        actionName: string;
        actionVal: string;
        message: string;
        platform: string;
        showWarning: boolean;
        forcefully: boolean;
      },
      public nodeService: NodeService,
      public snackBar: MatSnackBar,
      private spinner: NgxSpinnerService,
      private deploymentService: DeploymentService,
      private env: EnvironmentService
    ) {}

    ngOnInit() {
      console.log(this.actionName)
      if (this.actionName == PeroformNodeAction.TxtOpenConsole) {
        this.openConsoleAction = true;
      }
      this.nodeService.getUseVncFileTagValue(this.data.deployment).subscribe({
        next: (data: any) => {
          this.useVncFile = data.isUseVncFile;
          return;
        },
      });
    }

    onCancel() {
      this.dialog.close(false);
    }

    onSubmit() {
      if (this.data.actionName == "Delete") {
        return;
      }

      this.snackBar.open(this.data.actionName + " request sent", "Ok", {
        duration: 5000,
      });

      this.spinner.show("nodeAction");
      this.nodeService.triggerNodeAction(
        this.data.node,
        this.data.deployment,
        this.actionValue, this.data.platform, this.data.forcefully, this.useVncFile, this.data.nodeType,false
      ).subscribe({
        next: (res: any) => {
          if (this.actionValue == '3' || this.actionValue == '16') {
            this.executeConnect(res)
            return;
          }
          this.showSnackBar(res.body.actionMessage);
          this.dialog.close(true);
          this.spinner.hide("nodeAction");
        }, error:  (error: any) => {
          if (this.actionValue == '3') {
            if (this.data.platform.toLowerCase() == 'linux' && this.useVncFile != true) {
              this.showSnackBar(JSON.parse(error?.error).actionmessage);
            }
            else {
              this.showSnackBar(JSON.stringify(error?.actionmessage))
            }
            this.dialog.close(true);
            this.spinner.hide("nodeAction");
          }
          else if (this.actionValue == '16') {
            let errorMsg = error.actionMessage;
            this.showSnackBar(errorMsg)
            this.dialog.close(true);
            this.spinner.hide("nodeAction");
          }
          else {
            let errorMsg = JSON.parse(JSON.stringify(error)).error.actionMessage;
            this.showSnackBar(errorMsg)
            this.dialog.close(true);
            this.spinner.hide("nodeAction");
          }
        }
      });

      // this.dialog.close(true);
    }

    download(filename: string, fileData) {
      filename = filename.replace(/['"]+/g, "");
      let url = window.URL.createObjectURL(fileData);
      let elementAnchor = document.createElement("a");
      document.body.appendChild(elementAnchor);
      elementAnchor.setAttribute("style", "display: none");
      elementAnchor.href = url;
      elementAnchor.download = filename;
      elementAnchor.click();
      window.URL.revokeObjectURL(url);
      elementAnchor.remove();
    }

    showSnackBar(data) {
      if (!data) return;
      this.snackBar.open(data, "Ok", {
        duration: 5000,
      });
    }

    executeConnect(data) {
      if (
        this.data.platform.toLowerCase() == "windows" ||
        this.actionValue == "16"
      ) {
        if (data.headers.get("content-disposition"))
          this.download(
            data.headers.get("content-disposition").split(";")[1].split("=")[1],
            data.body
          );
      } else {
        if (data.headers.get("content-disposition"))
          this.download(
            data.headers.get("content-disposition").split(";")[1].split("=")[1],
            data.body
          );
        else {
          this.spinner.hide("nodeAction");
          this.dialog.close(true);
          let url = JSON.parse(data.body).actionMessage;
          let prof: Deployment = this.deploymentService.getProfileInfoFromSubject(
            this.data.deployment
          );
          if (prof) {
            if (prof.routeViaSynchpc) {
              url =
                this.env.envVariables.httpProtocol +
                this.env.envVariables.webHost.replace("api/", "novnc/") +
                url.split("://")[1];
            }
          }
          window.open(url, "_blank");
        }
      }
      this.dialog.close(true);
    }
  }
